import ENV from '../../run-config';

const { brand } = ENV;


const defaults = {
  primary1Color: '#2957A6', // '#4AB873'
  accent1Color: '#4AB873', // '#2957A6'
  accent2Color: '#4AB873',
  darkTextOnPrimaryBackground: false,
  zDepth: 1,
  positiveColor: '#53AF57',
  positiveColorTextColor: '#000',
  negativeColor: '#e30613',
  progressbarColor: '#53AF57',
  noProgressBgColor: '#2957A6',
  searchResultColor: '#fff176',
};

let color;

if (brand === 'whitelabel') {
  color = {
    primary1Color: '#2957A6', // '#4AB873'
    accent1Color: '#53AF57', // '#2957A6'
    accent2Color: '#53AF57',
    progressbarColor: '#53AF57',
    noProgressBgColor: '#2957A6',
    fullProgressbarColor: '#00921f',
  };
} else if (brand === 'msl') {
  color = {
    primary1Color: '#2957A6', // '#4AB873'
    accent1Color: '#53AF57', // '#2957A6'
    accent2Color: '#53AF57',
    progressbarColor: '#53AF57',
    noProgressBgColor: '#2957A6',
    fullProgressbarColor: '#00921f',
  };
} else if (brand === 'eba') {
  color = {
    primary1Color: '#28a9e0',
    accent1Color: '#8dc043',
    accent2Color: '#8c2f88',
    progressbarColor: '#8dc043',
    fullProgressbarColor: '#8dc043',
    noProgressBgColor: '#28a9e0',
  };
} else if (brand === 'rlb') {
  color = {
    darkTextOnPrimaryBackground: true,
    primary1Color: '#fbf315',
    accent1Color: '#666666',
    accent2Color: '#666666',
    progressbarColor: '#fbf315',
    fullProgressbarColor: '#00921f',
    zDepth: 0,
    positiveColor: '#fbf315',
    positiveColorTextColor: '#000',
    negativeColor: '#909090',
  };
} else if (brand === 'customerexpert') {
  color = {
    darkTextOnPrimaryBackground: false,
    primary1Color: '#cda300',
    accent1Color: '#000000',
    accent2Color: '#000000',
    progressBgColor: '#2957A6',
    noProgressBgColor: '#53AF57',
    // progressbarColor: '#53AF57',
    fullProgressbarColor: '#2957A6',
    zDepth: 0,
    positiveColor: '#cda300',
    positiveColorTextColor: '#ffff',
    negativeColor: '#61686f',
    searchButtonColor: '2957A6',
    searchButtonIconColor: '53AF57',
  };
} else if (brand === 'rlboe') {
  color = {
    darkTextOnPrimaryBackground: false,
    primary1Color: '#00335d',
    accent1Color: '#00335d',
    accent2Color: '#000000',
    progressBgColor: '#ffed00',
    noProgressBgColor: '#00335d',
    // progressbarColor: '#53AF57',
    fullProgressbarColor: '#ffed00',
    zDepth: 0,
    positiveColor: '#ffed00',
    positiveColorTextColor: '#000',
    negativeColor: '#00335d',
    searchButtonColor: 'ffed00',
    searchButtonIconColor: '000000',
  };
}


export default(Object.assign({}, defaults, color));




// WEBPACK FOOTER //
// ./src/app/theme/colors.js